import { render, staticRenderFns } from "./OTableNoticesComp.vue?vue&type=template&id=aae40268&"
import script from "./OTableNoticesComp.vue?vue&type=script&lang=js&"
export * from "./OTableNoticesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports